import {
  FETCH_MOULD_REQUEST,
  FETCH_MOULD_SUCCESS,
  FETCH_MOULD_FAILURE,
  ADD_MOULD_REQUEST,
  ADD_MOULD_SUCCESS,
  ADD_MOULD_FAILURE,
  UPDATE_MOULD_REQUEST,
  UPDATE_MOULD_SUCCESS,
  UPDATE_MOULD_FAILURE,
  DELETE_MOULD_REQUEST,
  DELETE_MOULD_SUCCESS,
  DELETE_MOULD_FAILURE,
  MOULD_FORM_ERROR,
  MOULD_FORM_SUCCESS,
  SET_MOULD_EDIT,
  CLEAR_MOULD_EDIT,
} from '../../../../types/masters/mould/mould/mouldTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingMould: null,
};

const mouldReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MOULD_REQUEST:
    case ADD_MOULD_REQUEST:
    case UPDATE_MOULD_REQUEST:
    case DELETE_MOULD_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_MOULD_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_MOULD_SUCCESS:
    case UPDATE_MOULD_SUCCESS:
    case DELETE_MOULD_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_MOULD_FAILURE:
    case ADD_MOULD_FAILURE:
    case UPDATE_MOULD_FAILURE:
    case DELETE_MOULD_FAILURE:
      return { ...state, loading: false, error: action.payload };
      case MOULD_FORM_ERROR:
        return {...state, loading:false, formError:action.payload};
      case MOULD_FORM_SUCCESS:
        return {...state, loading:false, formSuccess:action.payload};  
    case SET_MOULD_EDIT:
      return { ...state, editingMould: action.payload };
    case CLEAR_MOULD_EDIT:
      return { ...state, editingMould: null };
    default:
      return state;
  }
};

export default mouldReducer; 